import axiosInstance from ".";


export const createCategory = async ({ formData }) => {
    const response = await axiosInstance.post("/categories", formData, {
        "Content-Type": "multipart/form-data",
    })
    return response;
}
export const updateCategory = async (id, { formData }) => {
    const response = await axiosInstance.put(`/categories/${id}`, formData, {
        "Content-Type": "multipart/form-data",
    })
    return response;
}

export const getAllCategories = async () => {
    const response = await axiosInstance.get("/categories")
    return response;
}

export const getCategoryById = async ({ id }) => {
    const response = await axiosInstance.get(`/categories/${id}`)    
    return response;
}


export const deleteCategory = async ({ id }) => {
    const response = await axiosInstance.delete(`/categories/${id}`)
    return response;
}

export const updateCategorySequence = async ({ formData, categoryId }) => {
    const response = await axiosInstance.patch(`/categories/update-sequence/${categoryId}`, formData)
    return response;
}

